import NiceModal from '@ebay/nice-modal-react';
import { enqueueSnackbar } from 'notistack';
import { createAction } from 'redux-actions';

import { resetForm } from '@gef-ui/form-core/stream/transfer/control';
import { getLabelMessage, getMessage } from '@gef-ui/localization/messages';

import MODALS from 'constants/modals';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { addSingleErrorByPageAndId, resetErrorsByPage } from 'features/common/submitFormDialog/slice';
// eslint-disable-next-line import/no-cycle
import templates from 'features/views/campaignSettings/templates';
import user from 'features/views/user';

import * as types from './actionTypes';
import { SAVE_TEMPLATE_FORM_NAME } from './form';
import { getMaxTemplatesCount } from './selectors';

const saveTemplateTable = createAction(types.SAVE_TEMPLATES_TABLE);
const url = fetch.constants.urls.campaignPatternList;

export const resetTemplateTable = createAction(types.RESET);
export const showAllTemplates = createAction(types.SHOW_ALL_TEMPLATES);

export const removeTemplate = (templateId) => (dispatch) => {
	dispatch(
		fetch.actions.deleteRequest(fetch.constants.urls.campaignPatternDelete, {
			replaceParams: { id: templateId },
			onSuccess: [
				() => () => {
					dispatch(reload());
				},
			],
		}),
	);
};

export const applyTemplate = (templateId, campaignId, onSuccess) => (dispatch) => {
	dispatch(
		fetch.actions.put(fetch.constants.urls.campaignLoadPattern, {
			replaceParams: {
				id: templateId,
				campaignId,
			},
			onSuccess: [
				() => () => {
					dispatch(user.actions.fetchAdditionalUserInfo());
					NiceModal.hide(MODALS.campaignSettings_templates);
					enqueueSnackbar(getMessage('toastr:templateReadSucceeded'), { variant: 'success' });
					dispatch(resetTemplateTable());
					onSuccess();
				},
			],
		}),
	);
};

export const saveCampaignTemplate =
	(campaignId) =>
	async (dispatch, getState, { sendControlNext, getFormData }) => {
		const formData = await getFormData(SAVE_TEMPLATE_FORM_NAME);
		const name = formData.templateName;
		const templateList = templates.selectors.getTemplateTable(getState());
		const sameTemplateName = templateList.find((template) => template.name === name);
		const maxTemplatesCount = getMaxTemplatesCount(getState());
		const maxTemplatesCountReached = templateList.length >= maxTemplatesCount;

		const saveTemplate = fetch.actions.put(fetch.constants.urls.campaignPattern, {
			body: {
				name,
				campaignId,
				...(sameTemplateName && { id: sameTemplateName.id }),
			},
			onSuccess: [
				() => () => {
					dispatch(resetTemplateTable());
					enqueueSnackbar(getMessage('toastr:approveTemplateSave'), { variant: 'success' });
					sendControlNext(SAVE_TEMPLATE_FORM_NAME, resetForm());
					NiceModal.hide(MODALS.campaignSettings_templates);
				},
			],
		});

		if (sameTemplateName) {
			NiceModal.show(MODALS.lightbox_modal, {
				title: getLabelMessage('templates:existingTemplateNameWarning'),
				onConfirm: () => dispatch(saveTemplate),
			});
		} else {
			return maxTemplatesCountReached
				? dispatch(dialog.actions.open(SAVE_TEMPLATE_FORM_NAME))
				: dispatch(saveTemplate);
		}
	};

export const fetchCampaignTemplates = () => (dispatch, getState) => {
	const maxTemplatesCount = getMaxTemplatesCount(getState());

	dispatch(
		fetch.actions.get(url, {
			queryParams: {
				size: null,
				sort: 'modifiedDate,desc',
			},
			onSuccess: [
				(response) => () => {
					dispatch(saveTemplateTable(response.body));
					if (response.body.pageMetaData.totalRows >= maxTemplatesCount) {
						dispatch(dialog.actions.open(SAVE_TEMPLATE_FORM_NAME));
						dispatch(
							addSingleErrorByPageAndId({
								page: SAVE_TEMPLATE_FORM_NAME,
								errors: [
									{ name: 'saveTemplateMaxAmountReached', params: { maxCount: maxTemplatesCount } },
								],
							}),
						);
					}
				},
			],
		}),
	);
};

export const reload = () => (dispatch) => {
	dispatch(resetErrorsByPage({ page: SAVE_TEMPLATE_FORM_NAME }));
	dispatch(fetchCampaignTemplates());
};
